import { http } from './http'

export const apiAssetsList = (data: { page: number; page_size: number }) => {
  return http.post<any>('/api/ad_fashion/list/assets/photo', { data })
}

export const apiAddToAssets = (data: {
  image_id: string
  is_assets: boolean
}) => {
  return http.post<any>('/api/ad_fashion/add/assets/photo', { data })
}
